import type { CardState, DeckProgress } from '../../types/progress';

export const MASTERY_THRESHOLD = 3;

// ═══════════════════════════════════════════════════════
// Derivation Helpers (pure functions — no DB calls)
// ═══════════════════════════════════════════════════════

export function deriveAccuracy(state: CardState | null): number {
  if (!state) return 0;
  const total = (state.c || 0) + (state.w || 0);
  return total === 0 ? 0 : Math.round(((state.c || 0) / total) * 100);
}

export function deriveTotalAttempts(state: CardState | null): number {
  if (!state) return 0;
  return (state.c || 0) + (state.w || 0);
}

export function deriveIsMastered(state: CardState | null, threshold: number = MASTERY_THRESHOLD): boolean {
  if (!state) return false;
  return (state.s || 0) >= threshold;
}

export function deriveLastResult(state: CardState | null): 'correct' | 'wrong' | null {
  if (!state) return null;
  const total = (state.c || 0) + (state.w || 0);
  if (total === 0) return null;
  return (state.s || 0) > 0 ? 'correct' : 'wrong';
}

export function deriveProgress(deckProgress: DeckProgress | null): number {
  if (!deckProgress) return 0;
  const { seen = 0, total = 1 } = deckProgress;
  return total === 0 ? 0 : Math.round((seen / total) * 100);
}
